import React, { useState } from 'react';
import CustomInputField from '../CustomInput/CustomInputField';
import CustomFileUpload from '../CustomInput/CustomFileUpload';
import MobCamera from '../MobUpaod/MobCamera';
import { FileUploadHandlers } from '../KYCGuider/FileSpec';
import { UploadFile } from '../KYCGuider/FileUpload';
import { CloseEvent } from '../KYCGuider/CloseEvent';
import Checked from '../../images/icons/checkbox_ok.svg';
import Onload from '../../images/icons/loading2.svg';
import NotVerified from '../../images/icons/not_verified.svg';
import NotOK from '../../images/icons/verification_failed.svg';
import { getUserId } from '../../common/utils/cookie-utils';
import window from 'window-or-global';
import { getchequeOcr } from '../../common/constants/api';
import CommonInput from '../../components/Dashboard-res/CommonComponent/CommonInput';
import { useFormikContext } from 'formik';
import * as Yup from 'yup';
import { UpdateKYCstepAPI } from '../../common/constants/api';
import FileUpload from '../../images/icons/file_upload.svg';

const BankDetails = () => {
  let file_id;
  const {
    values,
    errors,
    touched,
    handleChange,
    handleBlur,
    status,
    isSubmitting,
    setFieldValue,
    setFieldTouched,
    setFieldError
  } = useFormikContext();

  const [submit, setSubmit] = useState(false);
  const setChanged = res => {
    let data = [
      { key: 'kyc_bank_name', value: 'bankName', editable: '' },
      { key: 'kyc_ifsc_code', value: 'ifsc', editable: '' },
      { key: 'kyc_acc_no', value: 'accountNumber', editable: '' },
      { key: 'kyc_bank_address', value: 'bankAddress', efitable: '' }
    ];
    for (let m = 0; m < data.length; m++) {
      try {
        let value = res[data[m].value];
        if (value) {
          setFieldValue(data[m].key, value);
        }
      } catch (e) {}
    }
  };

  const file_checker_not_ok = (id, error_message) => {
    if (window.innerWidth > 768) {
      let doc_error = document.getElementById(id + '_error');
      doc_error.style.display = 'block';
      doc_error.innerHTML = error_message;

      //change karne
      setTimeout(() => {
        document.getElementById(id + '_image').src = FileUpload;
      }, 500);
    }
  };

  const file_checker_ok = res => {
    let docTypeId;

    if (res === 'kyc_checque') {
      docTypeId = 13;
    } else {
      docTypeId = 14;
    }

    let data = {
      partnerId: parseInt(getUserId()),
      kycStepId: 5,
      docTypeId: docTypeId,
      fileType: 'png'
    };
    UploadFile(res, data, Upload_ok, Upload_not_ok);
  };

  const Upload_ok = res => {
    if (window.innerWidth > 768) {
      try {
        document.getElementById(file_id + '_image').src = Checked;
        document.getElementById(file_id + '_image').style.width = '28px';
      } catch {}
    }

    try {
      let addhar_id = ['kyc_checque', 'kyc_bank_statement'];
      CloseEvent(addhar_id, close_event_ok, close_event_not_ok);
    } catch (e) {}
    try {
      let data = {
        requestId: res.requestId
      };

      getchequeOcr(data)
        .then(res => setChanged(res))
        .catch(e => {});
    } catch (e) {}
    UpdateKYCstepAPI({
      url: res.url,
      requestId: res.requestId
    }).catch(err => {});
  };

  const Upload_not_ok = res => {
    if (window.innerWidth > 768) {
      try {
        document.getElementById(file_id + '_image').src = NotOK;
        document.getElementById(file_id + '_image').style.width = '28px';
      } catch {}
    }
  };

  const close_event_ok = () => {
    setSubmit(true);

    if (window.innerWidth > 768) {
      document.getElementById('web_address_image').src = NotVerified;
      document.getElementById('web_address_message').innerHTML =
        'Verification is Pending';
      document.getElementById('web_address_message').style.color = 'orange';
    }
  };

  const close_event_not_ok = () => {};

  const FileUploadHandler = id => {
    file_id = id;

    // Hide the visibility of the upload docs area
    if (window.innerWidth > 768) {
      document.getElementById(id + '_area').style.display = 'none';
      document.getElementById(id + '_image').src = Onload;
      document.getElementById(id + '_image').style.width = '28px';
    }
    try {
      // Upload the file

      FileUploadHandlers(id, file_checker_ok, file_checker_not_ok);
    } catch (e) {}
  };

  const ShowMobUpload = () => {
    let val1 = document.getElementById('kyc_enter_account_holder_name');
    let val2 = document.getElementById('kyc_enter_account_no');
    if (val1.value && val2.value) {
      document.getElementById('upload_front').style.display = 'block';
      let a = document.getElementById('doc_container');
      a.style.backgroundColor = 'black';
      a.style.height = '100%';
      a.style.position = 'absolute';
      a.style.opacity = '0.3';
      a.style.pointerEvents = 'none';
    }
    if (!val1.value) {
      val1.parentNode.parentNode.style.borderColor = 'red';
      val1.parentNode.parentNode.parentNode.children[1].innerHTML = 'required ';
      val1.parentNode.parentNode.parentNode.children[1].style.visibility =
        'visible';
    }
    if (!val2.value) {
      val2.parentNode.parentNode.style.borderColor = 'red';
      val2.parentNode.parentNode.parentNode.children[1].style.visibility =
        'visible';
      val2.parentNode.parentNode.parentNode.children[1].innerHTML = 'required ';
    }
  };

  return (
    <div className="w-full">
      <div
        className=" hidden w-full px-2 block md:block  bg-white  rounded-lg md:mx-auto  pt-8"
        id="doc_list_container"
      >
        <div className="w-full md:flex md:px-4 px-1 md:w-2/4 block">
          <div className=" w-full flex md:hidden  text-center mx-auto font-roboto font-bold">
            <p className="text-black-600 text-basic " id="pan_card_name">
              {' '}
            </p>
            <img
              className="w-4/12 md:w-3/4 mt-6 mb-8 mx-auto"
              id="card_photo"
              src=""
            />
            <img
              className="w-4/12 md:w-3/4 mt-6 mb-8 mx-auto"
              id="card_photo_back"
              src=""
            />

            <iframe
              className="md:w-3/4 mt-6 mb-8 mx-auto hidden"
              id="card_photo_iframe"
              src=""
            ></iframe>
          </div>
        </div>
        <div className="w-full flex" id="doc_value_container">
          <div
            className="w-full md:flex  hidden md:block bg-grey-0 px-4  md:px-0 md:bg-white rounded-lg  mx-auto mt-16 "
            id="upload_container"
          >
            <div className="w-1/2">
              <CustomFileUpload
                val={{
                  id: 'kyc_checque',
                  file_caption: 'Upload Cheque Leaf'
                }}
                file_handler={FileUploadHandler}
              />
            </div>

            <div className="w-1/2">
              <CustomFileUpload
                val={{
                  id: 'kyc_bank_statement',
                  file_caption: 'Upload 3 Months Bank Statement'
                }}
                file_handler={FileUploadHandler}
              />
            </div>
          </div>

          <div
            className="w-full md:w-2/4 md:hidden  visible  mx-auto md:block pt-3 pb-5"
            id="doc_values_division"
          >
            <div className="mt-10">
              <CommonInput
                name="kyc_account_holder_name"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.kyc_account_holder_name}
                stylesContainer={{
                  height: '52px',
                  maxWidth: '100%'
                }}
                legendName="Account Holder Name"
                error={
                  touched.kyc_account_holder_name &&
                  errors.kyc_account_holder_name
                }
                errorMsg={errors.kyc_account_holder_name}
                touched={touched.kyc_account_holder_name}
              />
            </div>
            <div className="mt-10">
              <CommonInput
                name="kyc_acc_no"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.kyc_acc_no}
                stylesContainer={{
                  height: '52px',
                  maxWidth: '100%'
                }}
                legendName="Account Number"
                error={touched.kyc_acc_no && errors.kyc_acc_no}
                errorMsg={errors.kyc_acc_no}
                touched={touched.kyc_acc_no}
              />
            </div>
            <div className="mt-10">
              <CommonInput
                name="kyc_ifsc_code"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.kyc_ifsc_code}
                stylesContainer={{
                  height: '52px',
                  maxWidth: '100%'
                }}
                legendName="IFSC Code"
                error={touched.kyc_ifsc_code && errors.kyc_ifsc_code}
                errorMsg={errors.kyc_ifsc_code}
                touched={touched.kyc_ifsc_code}
              />
            </div>
            <div className="mt-10">
              <CommonInput
                name="kyc_bank_name"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.kyc_bank_name}
                stylesContainer={{
                  height: '52px',
                  maxWidth: '100%'
                }}
                legendName="Bank Name"
                error={touched.kyc_bank_name && errors.kyc_bank_name}
                errorMsg={errors.kyc_bank_name}
                touched={touched.kyc_bank_name}
              />
            </div>
            <div className="mt-10">
              <CommonInput
                name="kyc_bank_address"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.kyc_bank_address}
                stylesContainer={{
                  height: '52px',
                  maxWidth: '100%'
                }}
                legendName="Bank Address"
                error={touched.kyc_bank_address && errors.kyc_bank_address}
                errorMsg={errors.kyc_bank_address}
                touched={touched.kyc_bank_address}
              />
            </div>
          </div>
        </div>
      </div>
      <MobCamera
        input_component="kyc_checque_m"
        main_id="upload_front"
        onchange={FileUploadHandler}
        caption="Upload Cheque Leaf"
      />
      <MobCamera
        input_component="kyc_bank_statement_m"
        main_id="upload_back"
        onchange={FileUploadHandler}
        caption="Upload 3 Month Bank Statement"
      />

      {submit ? (
        <button
          className=" submitButton w-56
                    lg:w-80  "
          type="submit"
          id="submit"
          disabled={
            errors.kyc_account_holder_name ||
            errors.kyc_acc_no ||
            errors.kyc_ifsc_code ||
            errors.kyc_bank_name ||
            errors.kyc_bank_address ||
            values.kyc_account_holder_name == '' ||
            values.kyc_acc_no == '' ||
            values.kyc_ifsc_code == '' ||
            values.kyc_bank_name == '' ||
            values.kyc_bank_address == ''
          }
        >
          CONTINUE
        </button>
      ) : null}
    </div>
  );
};
export default BankDetails;
